module.exports = __webpack_public_path__ + "img/8ebfbbdc7a95f4401002dd1ae9550393.b93cf13d.jpg";